import { Box, Button, Collapse, Icon, VStack } from '@chakra-ui/react'
import { useState } from 'react'
import { ChevronDownIcon, ChevronRightIcon } from '@chakra-ui/icons'

interface CollapsibleNavMenuProps {
  label: string
  children: React.ReactNode
}

const CollapsibleNavMenu = ({ label, children }: CollapsibleNavMenuProps) => {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <Box>
      <Button
        w="100%"
        variant="ghost"
        color="whiteAlpha.800"
        justifyContent="space-between"
        onClick={() => setIsOpen(!isOpen)}
        _hover={{ bg: 'whiteAlpha.100' }}
        rightIcon={
          <Icon
            as={isOpen ? ChevronDownIcon : ChevronRightIcon}
            transition="transform 0.2s"
          />
        }
      >
        {label}
      </Button>
      <Collapse in={isOpen}>
        <VStack
          pl={4}
          mt={1}
          alignItems="stretch"
          borderLeft="1px"
          borderColor="whiteAlpha.200"
        >
          {children}
        </VStack>
      </Collapse>
    </Box>
  )
}

export default CollapsibleNavMenu
